import React from 'react';
import './App.css';
import Controller from "./components/controller/Controller";

function App() {
  return (
    <Controller />
  );
}

export default App;
